import { render, staticRenderFns } from "./JcomGnoteList.vue?vue&type=template&id=793ea6d6"
import script from "./JcomGnoteList.vue?vue&type=script&lang=js"
export * from "./JcomGnoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports